import { useViewjobProctorAllocation } from '../../../../proctor/__generated__/ViewjobProctorContext';
import {
    CareerScoutAlwaysAware,
    CareerScoutStartersRandomOrderingVjTog,
} from '../../../../proctor/__generated__/ViewjobProctorSpecifications';

export const CAREER_SCOUT_ALWAYS_AWARE_BUCKETS = {
    MATCH_SECTION: CareerScoutAlwaysAware.buckets.Matchsection,
    SEPARATE: CareerScoutAlwaysAware.buckets.Separate,
    SCROLL: CareerScoutAlwaysAware.buckets.Scroll,
    ASK: CareerScoutAlwaysAware.buckets.Ask,
} as const;

export const useCareerScoutAlwaysAwareBucket = () =>
    useViewjobProctorAllocation(CareerScoutAlwaysAware).value;

export const useCareerScoutStartersRandomOrdering = (): boolean =>
    useViewjobProctorAllocation(CareerScoutStartersRandomOrderingVjTog).value > 0;
